import { NgModule } from "@angular/core";
import { TfSlideComponent } from "./components/tf-slide/tf-slide.component";
import { TfSliderComponent } from "./components/tf-slider/tf-slider.component";

@NgModule({
    declarations: [
        TfSliderComponent,
        TfSlideComponent
    ],
    exports: [
        TfSliderComponent,
        TfSlideComponent
    ],
    imports: []
})
export class TfSliderModule {
}
